// @flow

import * as React from "react"
import {connect} from "react-redux"
import ClassNames from "classnames"
import ProductListItem from "./product-list-item"
import {
  addProductToBabyList,
  removeBabyListItem,
  addOptional,
  removeOptional,
  updateBabyListItem,
} from "../actions/baby"
import {isProductOnBabyList, isProductInOptionals} from "../reducers/baby"
import {isProductRevealed} from "../reducers/products"
import type {
  ProductSet,
  ProductOrSet,
  BabyList,
  BabyListItem,
  ProductMedia,
  Dispatch,
  State as ReduxState,
} from "../types"

type Props = {
  +products: $ReadOnlyArray<ProductOrSet>,
  +toggleds: $ReadOnlyArray<ProductOrSet>,
  +revealeds: $ReadOnlyArray<ProductOrSet>,
  +dispatch: Dispatch,
  +babyList: BabyList,
  +media: $ReadOnlyArray<ProductMedia>,
  +optionals: $ReadOnlyArray<Product>,
  +babyToken: string,
  +isSummary: boolean,
}

type State = {}

class ProductList extends React.Component<Props, State> {
  static defaultProps = {
    isSummary: false,
  }

  handleAddProductToBabyList: (ProductOrSet, ?ProductSet) => void
  handleRemoveBabyListItem: (number) => void
  handleAddOptional: (ProductOrSet) => void
  handleRemoveOptional: (number) => void
  handleUpdateBabyListItem: (BabyListItem) => void

  constructor(props: Props) {
    super(props)

    this.handleAddProductToBabyList = this.handleAddProductToBabyList.bind(this)
    this.handleRemoveBabyListItem = this.handleRemoveBabyListItem.bind(this)
    this.handleAddOptional = this.handleAddOptional.bind(this)
    this.handleRemoveOptional = this.handleRemoveOptional.bind(this)
    this.handleUpdateBabyListItem = this.handleUpdateBabyListItem.bind(this)
  }

  handleAddProductToBabyList(product: ProductOrSet, productSet: ?ProductSet) {
    const {dispatch, babyToken} = this.props
    dispatch(addProductToBabyList(babyToken, product, productSet))
  }

  handleRemoveBabyListItem(babyItemId: number) {
    const {dispatch, babyToken} = this.props
    dispatch(removeBabyListItem(babyToken, babyItemId))
  }

  handleAddOptional(product: ProductOrSet) {
    const {dispatch, babyToken} = this.props
    dispatch(addOptional(babyToken, product))
  }

  handleRemoveOptional(optionalId: number) {
    const {dispatch, babyToken} = this.props
    dispatch(removeOptional(babyToken, optionalId))
  }

  handleUpdateBabyListItem(babyListItem: BabyListItem) {
    const {dispatch, babyToken} = this.props
    dispatch(updateBabyListItem(babyToken, babyListItem))
  }

  render() {
    const {products, babyList, isSummary, optionals, toggleds, revealeds} =
      this.props
    const className = ClassNames("product-list", {
      "is-summary": isSummary,
      "has-focused-item": toggleds && toggleds.length > 0,
    })
    return (
      <div className={className}>
        <ul className={className}>
          {products
            .filter(
              (prd) =>
                !prd.isHidden ||
                isProductOnBabyList(prd, babyList) ||
                isProductInOptionals(prd, optionals) ||
                isProductRevealed(revealeds, prd)
            )
            .map((product) => {
              const key = product.isSet
                ? `productSet-${product.id}`
                : `product-${product.id}`
              return (
                <React.Fragment key={key}>
                  <ProductListItem
                    product={product}
                    onAddToBabyList={this.handleAddProductToBabyList}
                    onRemoveFromBabyList={this.handleRemoveBabyListItem}
                    onAddOptional={this.handleAddOptional}
                    onRemoveOptional={this.handleRemoveOptional}
                    onUpdateBabyListItem={this.handleUpdateBabyListItem}
                    isSummary={isSummary}
                  />
                </React.Fragment>
              )
            })}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = (state: ReduxState): any => ({
  babyList: state.baby.list,
  optionals: state.baby.optionals,
  toggleds: state.products.toggleds,
  revealeds: state.products.revealeds,
})

export default connect(mapStateToProps)(ProductList)
